import { render, staticRenderFns } from "./Atribuicao.vue?vue&type=template&id=727fd794&"
import script from "./Atribuicao.vue?vue&type=script&lang=js&"
export * from "./Atribuicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports